<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title><router-link to="/" class="voltar"><img class="imgVoltar" :src="imgVoltar"></router-link>Lista de medicação</v-toolbar-title>
                    <v-btn v-if="perfil == 6" flat to="/criar-lembrete-medicacao" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>
                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row style="margin-bottom:5px; padding:1px">
                    
                    <v-card>
                    
                        <v-card-text>
                            <v-btn class="deletar" v-if="slugAutor == slugLogado" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn>
                            <v-card-title primary-title>
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div style="width:100%" class="body-content">
                                    
                                    <h3 class="headline mb-0" :title="item.titulo">{{item.titulo}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div>{{item.texto}}</div>
                                    <div>{{item.dateStart}}</div>
                                    <div>{{item.dateEnd}}</div>
                                    <div><b>Criado por:</b> {{item.nome}}</div><br />
                                    
                                </div>
                            </v-card-title>  

                            <v-card-actions>
                                <v-btn v-if="slugAutor == slugLogado" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <!--v-btn class="release" flat color="orange" flat="flat" @click="displayItem(item.slug)">Perfil</v-btn-->
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar lembrete de medicação?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Lembrete de medicação deletado com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js'

import imgVoltar from '../assets/ic-voltar.png';

export default {
    name: 'Lembrete-Medicacao-Listagem',
    data () {
        return {
            imgVoltar: imgVoltar,
            slug : null,
            slugAutor: null,
            slugLogado : null,
            dialogDeleteConfirm: false,
            dialog: false,
            loading: false,
            perfil: userProperties.perfil,
            modalMessage: 'Lembrete de medicação excluído com sucesso!',
            items: []
        }
    },
    methods: {
        carregaDados() {

            this.items = []
            this.loading = true
            let obj = []
            
            db.collection("medicacao")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    alert("Ainda não tem possui lembretes de medicação!");
                    this.loading = false;
                }
                else{
                    querySnapshot.forEach(doc => {
                    
                        var that = this;
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()

                        if(userProperties.perfil == 4 || userProperties.perfil == 5){
                            // Filtro para exibir somente aluno da turma do professor logado
                            usersData.slugUsuariosPorTurma.forEach(function(item, index){
                                //console.log(item + "==" + customObj.aluno.alunoSlug)
                                if(item == customObj.aluno.alunoSlug){
                                    if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                                        //that.items.push({"data":customObj.date, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "nomeAluno": customObj.aluno.alunoName, "slug": customObj.slug, slugAutor: customObj.slugAutor});
                                        that.items.push({"titulo":customObj.titulo, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "slug": customObj.slug, slugAutor: customObj.slugAutor});
                                    }
                                }
                            });
                        }
                        else{
                            //
                            userProperties.alunos.forEach(function(item, index){
                                if(item.alunoSlug == customObj.aluno.alunoSlug){
                                    that.items.push({"titulo":customObj.titulo, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "slug": customObj.slug, slugAutor: customObj.slugAutor});
                                }
                                
                            });
                            //if(that.$route.query.slugAluno == undefined || that.$route.query.slugAluno == customObj.aluno.alunoSlug){
                                //that.items.push({"titulo":customObj.titulo, "texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "nome": customObj.nome, "slug": customObj.slug, slugAutor: customObj.slugAutor});
                            //}
                        }

                        
                        this.slug = customObj.slug;
                        this.slugAutor = customObj.slugAutor;
                        this.loading = false
                        
                    });
                }
                
            });
            //console.log(this.items);
            // this.items = obj
        },
        editarItem(slug){
            this.$router.push(`/editar-lembrete-medicacao/?slug=`+slug)

        },
        displayItem(slug){
            this.$router.push(`/xxx/?slug=`+slug)

        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("medicacao").where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }
        
            
        
    },
    created() {
        this.slugLogado = userProperties.slug;
        this.carregaDados();
        

        console.log("alunos");
        console.log(userProperties.alunos);
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:46%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;
        display: none;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .imagem{
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top: -8px;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }
</style>
